"use client"

import { Box, Typography, Stack } from "@mui/material"
import { Speed, Security } from "@mui/icons-material"

const features = [
  {
    icon: Speed,
    title: "Análise Lighthouse",
    description: "Avalia a acessibilidade, desempenho e boas práticas dos sites para garantir uma experiência digital inclusiva e eficiente.",
  },
  {
    icon: Security,
    title: "Confiabilidade e Durabilidade",
    description: "Monitoramento contínuo e consistente que assegura melhorias duradouras na acessibilidade digital.",
  },
]


export default function FeatureList() {
  return (
    <Stack spacing={4} sx={{ maxWidth: 500 }}>
      {features.map((feature, index) => (
        <Box key={index} sx={{ display: "flex", gap: 2, alignItems: "flex-start" }}>
          <Box
            sx={{
              p: 1,
              borderRadius: 1,
              bgcolor: "var(--color-primary)",
              color: "var(--color-primary)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              minWidth: 40,
              height: 40,
            }}
          >
            <feature.icon sx={{ fontSize: 20, color: "var(--color-background)" }} />
          </Box>
          <Box>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 600,
                mb: 0.5,
                fontSize: "1.0rem",
              }}
            >
              {feature.title}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.0 }}>
              {feature.description}
            </Typography>
          </Box>
        </Box>
      ))}
    </Stack>
  )
}
